import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import { useState } from "react";
import { useParams } from "react-router";
import { useAppContext } from "../../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../../controller/article/ArticleController";
import { UserController, UserControllerType } from "../../../../controller/user/UserController";
import ArticleDto from "../../../../model/manuscript/ArticleDto";
import SubmitService, { SubmitServiceType } from "../../../../service/manuscript/SubmitService";
import { handleErrorMessage, richTextStateFromHTML, useEffectOnce } from "../../../../utils/Utils";
import Authors from "../submit/authors/Authors";
import GeneralInformation from "./general-information/GeneralInformation";
import Overview from "./overview/Overview";
import PaperFiles from "./paper-files/PaperFiles";
import Reviewers from "./reviewers/Reviewers";
import { useStyles } from "./SubmitStyle";

const abstractInit = "<p>INTRODUCTION:</p><br><p>METHODS:</p><br><p>RESULTS:</p><br><p>CONCLUSION:</p>";

export default function Submit() {
  const { steps, ColorlibStepIcon, ColorlibConnector }: SubmitServiceType = SubmitService();

  const { axiosGetArticleById, axiosGetKeywords, axiosGetTypes }: ArticleControllerType = ArticleController();
  const { axiosGetReviewerList }: UserControllerType = UserController();
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const { id }: any = useParams();
  const { showMessage } = useAppContext();

  const [article, setArticle] = useState<ArticleDto>({
    id: "",
    active: "",
    articleTitle: "",
    abstractText: richTextStateFromHTML(abstractInit),
    type: "",
    coverLetter: "",
    reviewerOne: "",
    reviewerTwo: "",
    reviewerRemoved: "",
    reviewerRequired: "",
    keywords: "",
    status: "",
    uploadDate: "",
    lastUpdate: "",
    revision: "",
    relationshipOne: "",
    relationshipTwo: "",
    acceptedDate: "",
    ithenticateId: "",
    ithenticateUrl: "",
    firstTime: "",
    previousId: "",
    languageService: false,
    createDate: "",
    authorsIds: [],
    uploadedById: "",
    associateEditorId: "",
    fileList: [],
  });

  useEffectOnce(() => {
    if (!id) {
      setLoading(true);
    } else {
      axios
        .all([axiosGetTypes(), axiosGetKeywords(), axiosGetReviewerList(), axiosGetArticleById(id)])
        .then(
          axios.spread((resposneTypeList, responseKeyword, responseReviewrList, responseArticle) => {
            const keywordsArray = responseArticle.data.keywords.split(";");

            const reviewerOne = responseReviewrList.data.find(
              (u: any) => u.id === parseInt(responseArticle.data.reviewerOne)
            );

            const reviewerTwo = responseReviewrList.data.find(
              (u: any) => u.id === parseInt(responseArticle.data.reviewerTwo)
            );
            const reviewerRemoved = responseReviewrList.data.find(
              (u: any) => u.id === parseInt(responseArticle.data.reviewerRemoved)
            );

            setArticle({
              ...responseArticle.data,
              authorsIds: [],
              type: resposneTypeList.data.find((t: any) => t.id === responseArticle.data.type?.id),
              keywords: responseKeyword.data.filter((f: any) => keywordsArray.includes(f.keyword)),
              coverLetter: richTextStateFromHTML(responseArticle.data.coverLetter),
              abstractText: richTextStateFromHTML(responseArticle.data.abstractText),
              reviewerOne: reviewerOne
                ? { name: reviewerOne.firstName + " " + reviewerOne.lastName, code: reviewerOne.id }
                : "",
              reviewerTwo: reviewerTwo
                ? { name: reviewerTwo.firstName + " " + reviewerTwo.lastName, code: reviewerTwo.id }
                : "",
              reviewerRemoved: reviewerRemoved
                ? {
                    name: reviewerRemoved.firstName + " " + reviewerRemoved.lastName,
                    code: reviewerRemoved.id,
                  }
                : "",
              fileList: responseArticle.data.files,
              articleAuthors: responseArticle.data.articleAuthors,
            });
            setLoading(true);
          })
        )
        .catch((error: any) => {
          handleErrorMessage(showMessage, error);
        });
    }
  });

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <GeneralInformation article={article} setArticle={setArticle} handleNext={handleNext} />;
      case 1:
        return <Authors article={article} setArticle={setArticle} handleNext={handleNext} handleBack={handleBack} />;
      case 2:
        return <Reviewers article={article} setArticle={setArticle} handleNext={handleNext} handleBack={handleBack} />;
      case 3:
        return <PaperFiles article={article} setArticle={setArticle} handleNext={handleNext} handleBack={handleBack} />;
      case 4:
        return <Overview steps={steps} article={article} handleBack={handleBack} />;
      default:
        return "Unknown step";
    }
  };

  if (!loading) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
        {steps.map((label: string) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              <Typography>{label}</Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <Typography className={classes.instructions}>
        <div className={classes.conteredContentContainer}>{getStepContent(activeStep)}</div>
      </Typography>
    </div>
  );
}
